var render, staticRenderFns
import script from "./WxSkeletonLoader.vue?vue&type=script&lang=js"
export * from "./WxSkeletonLoader.vue?vue&type=script&lang=js"
import style0 from "./WxSkeletonLoader.vue?vue&type=style&index=0&id=62f2a4c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f2a4c8",
  null
  
)

export default component.exports